module.exports = __webpack_public_path__ + "img/Bild_linda.580b94a5.jpg";